import { MDBAlert, MDBBtn, MDBDataTable, MDBIcon } from "mdbreact"
import React from "react"
import Select from 'react-select'
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Collapse, Container, Form, Input, Modal, ModalBody, ModalFooter, ModalHeader, Label, Media, Row, Spinner } from "reactstrap"
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import _valid from "../../validations"

const columns = [
    {
        label: "Código",
        field: "articulo_codigo",
        sort: "asc",
    },
    {
        label: "Nombre",
        field: "articulo_nombre",
        sort: "asc",
        width: 150,
    },
    {
        label: "Descripción",
        field: "articulo_descripcion",
        sort: "asc",
        width: 150,
    },
    {
        label: "Serie",
        field: "articulo_serie",
        sort: "asc",
        width: 150,
    },
    {
        label: "Cantidad",
        field: "cantidad",
        sort: "asc",
        width: 150,
    },
    {
        label: "Departamento/Area",
        field: "departamento_area_nombre",
        sort: "asc",
        width: 150,
    },
    {
        label: "Ubicación Fisica",
        field: "area_trabajo_nombre",
        sort: "asc",
        width: 150,
    },
    {
        label: "Estado",
        field: "estado",
        sort: "asc",
        width: 150,
    }
];

export default class TajetaResponsabilidadTraslado extends React.Component {
    
    constructor(props) {
        super(props);

        this.apiRest = new ApiRest(props);

        this.state = {
            registro: _valid(this.props.location.registro) ? this.props.location.registro : {
                nombre: ''
            },
            tabla: { columns: columns, rows: [] },
            colapsar: true,
            registroTraslado: {},
            camposRequeridos: [],
            colaboradores: [],
            mostrarSpinner: false,
            errors:{}
        };
    }

    componentDidMount() {
        this.cargarListado();
    }

    colapsar() {
        this.setState(estadoAnterior => ({ colapsar: !estadoAnterior.colapsar }));
    }

    cargarListado = () => {
        this.setState( { mostrarSpinner: true });
        this.apiRest.get('/tarjetaResponsabilidadArticulos/' + this.state.registro.id).then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({  mostrarSpinner: false, tabla: { columns, rows: respuesta.data } });
            }
        });
        this.obtenerColaboradores();
    }    

    trasladarTarjeta = () => {
        if (this.datosRegistroValidos()) {
            let registroTraslado = this.state.registroTraslado;
            registroTraslado.idTarjetaResponsabilidad = this.state.registro.id;

            this.setState({ mostrarSpinner: true });

            this.apiRest.post('/tarjetaResponsabilidadTrasladoMasivo', registroTraslado).then(resultado => {
                if (resultado.exitoso) {
                    toastr.success('Datos almacenados exitosamente!');
                    this.cargarListado();
                    this.setState({ mostrarSpinner: false });
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        }
    }
    
    setColaborador = colaborador => {
        this.setState(estadoAnterior => ({
            registroTraslado: { ...estadoAnterior.registroTraslado, ['idColaborador']: colaborador.id }
        }));
    }

    setValuesTraslado = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            registroTraslado: { ...estadoAnterior.registroTraslado, [name]: value }
        }));
    }

    obtenerColaboradores = () => {
        if (this.apiRest.getRol()) {
            this.apiRest.get('/colaborador').then(respuesta => {
                if (respuesta.exitoso) {
                    this.setState({ colaboradores: respuesta.data });
                } else {
                    this.setState({ colaboradores: [] });
                }
            });
        } else {
            if (this.apiRest.getLS('idEmpresa')) {
                this.apiRest.getColaborador('/getColaborador/').then(respuesta => {
                    if (respuesta.exitoso) {
                        this.setState({ colaboradores: respuesta.data });
                    } else {
                        this.setState({ colaboradores: [] });
                    }
                });
            }
        }
    }

    datosRegistroValidos() {
        const { registro, registroTraslado, camposRequeridos } = this.state;

        let existenErrores = false
        if (!_valid(registro.id)) {
            camposRequeridos.push("Tarjeta de Responsabilidad Origen");
            existenErrores = true;
        }
        if (!_valid(registroTraslado.idColaborador)) {
            camposRequeridos.push("Colaborador");
            existenErrores = true;
        }        
        if (!_valid(registroTraslado.motivo_desasignado)) {
            camposRequeridos.push("Motivo");
            existenErrores = true;
        }
        if (!_valid(registroTraslado.razon_desasignado)) {
            camposRequeridos.push("Razón");
            existenErrores = true;
        }

        if (existenErrores) {
            this.setState({ camposRequeridos: camposRequeridos });
            setTimeout(() => this.setState({ camposRequeridos: [] }), 3000);
        }

        return !existenErrores;
    }

    render() {
        const { registro, colapsar, camposRequeridos, mostrarSpinner } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Activos" breadcrumbItem="Trasladar tarjeta de Responsabilidad" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Link onClick={() => this.colapsar()} className="text-dark" to="#">
                                            <div className="mb-2 mb-2">
                                                <Media className="d-flex align-items-center">
                                                    
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-18 mb-1">Trasladar tarjeta de Responsabilidad</h5>                                                        
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <Collapse isOpen={colapsar}>
                                            <Row>
                                                <Col lg={5}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="colaborador_actual" className="form-label">
                                                            Colaborador actual
                                                        </Label>
                                                        <select
                                                            name="colaborador_actual"
                                                            onChange={this.setValuesTraslado}
                                                            className="form-control">
                                                            <option value="1">{registro.colaborador_label}</option>
                                                        </select>
                                                    </div>
                                                </Col>
                                                <Col lg={2} className="d-flex align-items-center justify-content-center"> 
                                                    <div className="mb-3 mb-4"> <i className="fas fa-arrow-right"></i> </div> 
                                                </Col>
                                                <Col lg={5}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="nuevo_colaborador" className="form-label">
                                                            Nuevo colaborador
                                                        </Label>
                                                        <Select
                                                            name="colaboradorSelectValue"
                                                            options={this.state.colaboradores}
                                                            onChange={this.setColaborador}>
                                                        </Select>
                                                        <div className={this.state.errors.articuloRequerido ? 'error' : 'hidden'}>Requerido</div>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg={5}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="razon_desasignado" className="form-label">
                                                            Raz&oacute;n
                                                        </Label>
                                                        <select
                                                            name="razon_desasignado"
                                                            onChange={this.setValuesTraslado}
                                                            className="form-control">
                                                            <option value="">Seleccionar</option>
                                                            <option value="1">Traslado</option>
                                                            <option value="2">Venta</option>
                                                            <option value="3">Inventario</option>
                                                            <option value="4">Otro</option>
                                                        </select>
                                                    </div>
                                                </Col>
                                                <Col lg={7}>
                                                    <div className="mb-3 mb-4">
                                                        <Label htmlFor="motivo_desasignado" className="form-label">
                                                            Motivo
                                                        </Label>
                                                        <Input
                                                            name="motivo_desasignado"
                                                            onChange={this.setValuesTraslado}
                                                            type="text"
                                                            maxLength="250"
                                                            className="form-control"
                                                            placeholder="Ingresa el motivo"/>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                {_valid(camposRequeridos) && camposRequeridos.map((campo, index) => <MDBAlert key={index} color="danger"><strong>{campo}</strong> es requerido.</MDBAlert>)}
                                            </Row>
                                            <Row>
                                                
                                                <Col lg={12}>                                                    
                                                    {
                                                        mostrarSpinner ?
                                                        <Row>
                                                            <Col style={{ display: "flex", justifyContent: "center" }}>
                                                                <Spinner className="m-1" color="primary" />
                                                            </Col>
                                                        </Row>
                                                        :
                                                        <MDBBtn className="waves-effect"color="primary" onClick={() => this.trasladarTarjeta()}>
                                                            <MDBIcon icon="fas fa-user-plus" />{' '}
                                                            Trasladar
                                                        </MDBBtn>
                                                    }

                                                    
                                                </Col>
                                                
                                            </Row>
                                            &nbsp;
                                            <div className="p-4 border-top">
                                                <Form>
                                                    <Row>
                                                        <Col lg={12}>                  
                                                            <div className="table-responsive">                                          
                                                                <MDBDataTable hover searchLabel="Buscar.." paginationLabel={["Anterior", "Siguiente"]} noRecordsFoundLabel="No hay datos." infoLabel={["Mostrando desde ", "hasta", " | Entradas totales: ", ""]} entriesLabel="Mostrando entradas" data={this.state.tabla} />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Form>
                                            </div>

                                            <Row>
                                                <Col lg={12} className="text-end">
                                                    <MDBBtn className="waves-effect"color="danger" onClick={() => { this.props.history.replace('/tarjetaResponsabilidadListado') }}>
                                                        <MDBIcon icon="fas fa-arrow-left" />{' '}
                                                        Regresar
                                                    </MDBBtn>
                                                    {' '}
                                                    <MDBBtn className="waves-effect"color="success" onClick={() => this.almacenarRegistro()}>
                                                        <MDBIcon icon="fas fa-user-check" /> {' '}
                                                        Listo
                                                    </MDBBtn>
                                                </Col>
                                            </Row>
                                        </Collapse>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
                
            </React.Fragment>
        );
    }
}